export enum ErrorViewTrackingEnumeration {
  GENERIC_ERROR = 'genericError',
  SIGNATURE = 'signature',
  VALIDATE_THE_DOCUMENTS = 'validateTheDocuments',
  VERIFY_IDENTITY = 'verifyIdentity',
  VERIFY_INCOME = 'verifyIncome',
  PAYMENT = 'payment',
}
